import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';

import * as Yup from 'yup';

const {
  formField: { systemPropertyOwnershipStatus, systemPropertyOwnerBusinessName },
} = loanFormModel;

export class PropertyLegalNameOfOwnerValidation implements ValidationSchema {
  public name: string = systemPropertyOwnerBusinessName.name;
  public label = '';
  public dependsOn: string[] = [systemPropertyOwnershipStatus.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(ownershipType: string, schema: Yup.StringSchema) {
    if (ownershipType === 'LEASED')
      return schema.required(systemPropertyOwnerBusinessName.requiredErrorMsg);
    return schema;
  }
}
export default new Validation(new PropertyLegalNameOfOwnerValidation());
